"use client";

import { c as _c } from "react/compiler-runtime";
import { PreviewCard as PreviewCardPrimitive } from "@base-ui/react/preview-card";
import { cn } from "@/lib/utils";
function HoverCard(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <PreviewCardPrimitive.Root data-slot="hover-card" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function HoverCardTrigger(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <PreviewCardPrimitive.Trigger data-slot="hover-card-trigger" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function HoverCardContent(t0) {
  const $ = _c(18);
  let className;
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t0) {
    ({
      className,
      side: t1,
      sideOffset: t2,
      align: t3,
      alignOffset: t4,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  const side = t1 === undefined ? "bottom" : t1;
  const sideOffset = t2 === undefined ? 4 : t2;
  const align = t3 === undefined ? "center" : t3;
  const alignOffset = t4 === undefined ? 4 : t4;
  let t5;
  if ($[7] !== className) {
    t5 = cn("data-open:animate-in data-closed:animate-out data-closed:fade-out-0 data-open:fade-in-0 data-closed:zoom-out-95 data-open:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ring-foreground/10 bg-popover text-popover-foreground z-50 w-64 origin-(--transform-origin) rounded-lg p-4 text-sm shadow-md ring-1 outline-hidden duration-100", className);
    $[7] = className;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== props || $[10] !== t5) {
    t6 = <PreviewCardPrimitive.Popup data-slot="hover-card-content" className={t5} {...props} />;
    $[9] = props;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== align || $[13] !== alignOffset || $[14] !== side || $[15] !== sideOffset || $[16] !== t6) {
    t7 = <PreviewCardPrimitive.Portal data-slot="hover-card-portal"><PreviewCardPrimitive.Positioner align={align} alignOffset={alignOffset} side={side} sideOffset={sideOffset} className="isolate z-50">{t6}</PreviewCardPrimitive.Positioner></PreviewCardPrimitive.Portal>;
    $[12] = align;
    $[13] = alignOffset;
    $[14] = side;
    $[15] = sideOffset;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
export { HoverCard, HoverCardTrigger, HoverCardContent };